<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Thời khóa biểu*"
          :link="[
            {
              text: 'Thời khóa biểu*',
              href: '../time-table-conf1g'
            }
          ]"
        />
      </div>
      <div class="flex-center" v-if="role.type !== 'inspector'">
        <v-btn color="primary" class="elevation-0" @click="upload">
          <span>Upload tệp</span>
          <input ref="uploader" type="file" class="d-none" accept=".pdf, .xlsx, .doc, .docx" @change="onFileChanged" />
        </v-btn>
      </div>
    </div>

    <v-card outlined class="mx-4 elevation-0">
      <OldTimeTableDataTable ref="table" />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapGetters } from 'vuex'
import OldTimeTableDataTable from './components/OldTimetable.vue'

export default {
  components: {
    Breadcrumbs,
    OldTimeTableDataTable
  },
  data() {
    return {
      isSelecting: false,
      typeId: '',
      documentType: {},
      selecteds: []
    }
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role', 'user'])
  },
  async created() {
    const type = await this.fetchInspectionTimtableDocType()
    this.typeId = type.id
  },
  methods: {
    ...mapActions('Documents', [
      'createDocument',
      'removeDocument',
      'removeDocuments',
      'fetchDocumentType',
      'searchDocuments',
      'requestPageSettings',
      'fetchInspectionTimtableDocType'
    ]),
    ...mapActions('upload', ['uploadFile']),

    upload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      const file = e.target.files[0]

      let createdDocument = {}
      try {
        // create document
        const data = {
          documentType: this.typeId,
          createdUser: this.user.id
        }
        createdDocument = await this.createDocument(data)
        // upload file
        let formData = new FormData()
        formData.append('files', file)
        formData.append('refId', createdDocument.id)
        formData.append('ref', 'document')
        formData.append('field', 'file')

        await this.uploadFile(formData)

        this.$alert.success('Tải file thành công')
        await this.$refs.table.refresh({ documentType: this.typeId })
      } catch (error) {
        this.$alert.error('Tải file thất bại, vui lòng thử lại. Lỗi: ' + error)
        if (createdDocument.id) await this.removeDocument(createdDocument.id)
      } finally {
        this.$loading.active = false
      }
    },
    async search() {
      await this.$refs.table.refresh({ documentType: this.typeId })
    }
  }
}
</script>
